import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "lnr_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

// Resolve image src: absolute URLs pass through; relative /api/files paths get the backend prefix.
export const imgUrl = (src) => {
  if (!src) return "";
  return src.startsWith("http") ? src : `${BACKEND_URL}${src}`;
};

export const formatRON = (n) =>
  new Intl.NumberFormat("ro-RO", { maximumFractionDigits: 0 }).format(n) + " lei";

// Public
export const fetchProducts = async () => (await api.get("/products")).data;
export const fetchProduct = async (slug) => (await api.get(`/products/${slug}`)).data;
export const createOrder = async (payload) => (await api.post("/orders", payload)).data;
export const createStripeCheckout = async (payload) => (await api.post("/payments/checkout", payload)).data;
export const getPaymentStatus = async (sessionId) => (await api.get(`/payments/status/${sessionId}`)).data;

// Auth
export const adminLogin = async (email, password) => (await api.post("/auth/login", { email, password })).data;
export const fetchMe = async () => (await api.get("/auth/me", { headers: authHeaders() })).data;

// Admin
export const adminFetchProducts = async () => (await api.get("/admin/products", { headers: authHeaders() })).data;
export const adminUpdateProduct = async (id, payload) =>
  (await api.put(`/admin/products/${id}`, payload, { headers: authHeaders() })).data;
export const adminUploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return (await api.post("/admin/upload", fd, { headers: { ...authHeaders(), "Content-Type": "multipart/form-data" } })).data;
};

// Customer
export const registerUser = async (name, email, password) => (await api.post("/auth/register", { name, email, password })).data;
export const fetchMyOrders = async () => (await api.get("/my/orders", { headers: authHeaders() })).data;
export const trackOrder = async (num) => (await api.get(`/track/${encodeURIComponent(num)}`)).data;

// Storefront extras
export const validateVoucher = async (code) => (await api.post("/vouchers/validate", { code })).data;
export const subscribeNewsletter = async (email) => (await api.post("/newsletter", { email })).data;
export const notifyStock = async (slug, email) => (await api.post(`/products/${slug}/notify`, { email })).data;
export const fetchContent = async () => (await api.get("/content")).data;
export const fetchCategories = async () => (await api.get("/categories")).data;

// Admin extras
export const adminCreateProduct = async (p) => (await api.post("/admin/products", p, { headers: authHeaders() })).data;
export const adminDeleteProduct = async (id) => (await api.delete(`/admin/products/${id}`, { headers: authHeaders() })).data;
export const adminStats = async () => (await api.get("/admin/stats", { headers: authHeaders() })).data;
export const adminOrders = async () => (await api.get("/admin/orders", { headers: authHeaders() })).data;
export const adminUpdateOrder = async (id, status) => (await api.put(`/admin/orders/${id}`, { status }, { headers: authHeaders() })).data;
export const adminDeleteOrder = async (id) => (await api.delete(`/admin/orders/${id}`, { headers: authHeaders() })).data;
export const adminOrderInvoice = async (id) => (await api.post(`/admin/orders/${id}/invoice`, {}, { headers: authHeaders() })).data;
export const adminCreateCategory = async (body) => (await api.post("/admin/categories", body, { headers: authHeaders() })).data;
export const adminUpdateCategory = async (slug, body) => (await api.put(`/admin/categories/${slug}`, body, { headers: authHeaders() })).data;
export const adminDeleteCategory = async (slug) => (await api.delete(`/admin/categories/${slug}`, { headers: authHeaders() })).data;
export const adminVouchers = async () => (await api.get("/admin/vouchers", { headers: authHeaders() })).data;
export const adminCreateVoucher = async (v) => (await api.post("/admin/vouchers", v, { headers: authHeaders() })).data;
export const adminDeleteVoucher = async (code) => (await api.delete(`/admin/vouchers/${code}`, { headers: authHeaders() })).data;
export const adminNewsletter = async () => (await api.get("/admin/newsletter", { headers: authHeaders() })).data;
export const adminNotifications = async () => (await api.get("/admin/notifications", { headers: authHeaders() })).data;
export const adminUpdateContent = async (body) => (await api.put("/admin/content", body, { headers: authHeaders() })).data;
export const adminDownloadOrdersCsv = async () => {
  const res = await api.get("/admin/orders.csv", { headers: authHeaders(), responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url; a.download = "lainer_orders.csv"; a.click();
  window.URL.revokeObjectURL(url);
};
